import { styled, Box, Link } from '@material-ui/core';
import { QRCodeSVG } from 'qrcode.react';

const QRCodeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  borderRadius: 16,
  padding: 24,
}));

const QRCodeWrapper = styled(Box)({
  width: '30%',
});

const TextWrapper = styled(Box)({
  width: '70%',
});

const QRCode = styled(QRCodeSVG)({
  width: 120,
  height: 120,
});

const StoreImgWrapper = styled('a')({
  display: 'flex',
  justifyContent: 'center',
  width: 'fit-content',
  margin: '0 auto',
  marginTop: 16,
});

const FormContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  backgroundColor: theme.palette.background.paper,
  borderRadius: 16,
  padding: 24,
  marginBottom: 16,
  marginTop: 24,
}));

const CustomLink = styled(Link)({
  fontSize: 16,
  padding: 0,
  margin: 0,
  verticalAlign: 'baseline',
  display: 'inline',
  cursor: 'pointer',
});

export {
  QRCodeContainer,
  QRCode,
  StoreImgWrapper,
  QRCodeWrapper,
  TextWrapper,
  FormContainer,
  CustomLink,
};
